"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateChecklistFrequency = validateChecklistFrequency;
/**
 * Validates a checklist activity frequency (in days).
 *
 * The frequency is the number of days between occurrences of a recurring task.
 * - `null`/`undefined` → no fixed cadence (valid; the task is never "overdue").
 * - otherwise → must be an integer ≥ 1.
 *
 * @param value - frequency in days, or null/undefined for "no cadence"
 * @returns ValidationResult with isValid flag and optional error message
 */
function validateChecklistFrequency(value) {
    if (value === null || value === undefined) {
        return { isValid: true };
    }
    if (typeof value !== 'number' || Number.isNaN(value) || !Number.isInteger(value)) {
        return {
            isValid: false,
            error: 'La frecuencia debe ser un número entero de días',
        };
    }
    if (value < 1) {
        return { isValid: false, error: 'La frecuencia debe ser al menos 1 día' };
    }
    return { isValid: true };
}
